module.exports = ":host {\n  display: block;\n  overflow: hidden; }\n\n.error-msg {\n  color: #DA291C;\n  font-family: Roboto;\n  font-size: 0.8rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/input-error/input-error.component.scss
// module id = ./libs/atenea-cms/src/input-error/input-error.component.scss
// module chunks = main